import Simulation from "../simulation";
import ChangeManagementWelcome1 from "./ChangeManagementWelcome1"
import ChangeManagementSection3 from "./ChangeManagementSection3";


export default {
  name: "ChangeManagement",
  props: ['iframesrc', 'module', 'activity', 'lesson'],

  /**
   *
   */
  data () {
    return {
      currentSection: 1,
    }
  },
  computed: {
    section2Locked: function() {
      return this.module.model.lessons[0].activities.some( activity => !activity.completed )
    },
    section3Locked: function() {
      return this.module.model.lessons[1].activities.some( activity => !activity.completed )
    }
  },
  /**
   *
   */
  methods: {
    setSectionOne () {
      this.currentSection = 1;
      this.setActivity(this.module.model.lessons[0].activities[0],this.module.model.lessons[0])
    },
    setSectionTwo () {
      if (!this.section2Locked) {
        this.currentSection = 2
        this.setActivity(this.module.model.lessons[1].activities[0],this.module.model.lessons[1])
      }
    },
    setSectionThree () {
      if (!this.section3Locked) {
        this.currentSection = 3
        this.setActivity(this.module.model.lessons[2].activities[0],this.module.model.lessons[2])
      }
    },
    setActivity (activity, lesson) {
      this.$emit('setact', activity, lesson)
    },
    completeActivity () {
      this.$emit('complete')
    },
    /**
     *
     * @param activity
     * @returns {*}
     */
    getActivityIcon(activity) {
      if (activity.completed) {
        return (
          <div class="flex-shrink-0 w-5 lg:w-6 h-5 lg:h-6 rounded-full text-white bg-brand-green-400 text-center mr-1 lg:leading-6">
            <i class="mdi mdi-check"></i>
          </div>
        );
      }

      return this.activity && this.activity.id === activity.id ? (
        <div class="flex-shrink-0 w-5 lg:w-6 h-5 lg:h-6 rounded-full text-white bg-brand-orange-700 text-center mr-1 lg:leading-6">
          {activity.sequence}
        </div>
      ) : (
        <div class="flex-shrink-0 w-5 lg:w-6 h-5 lg:h-6 rounded-full text-gray-400 bg-brand-gray-500 text-center mr-1 lg:leading-6">
          {activity.sequence}
        </div>
      );
    },
  },
  watch: {
    activity: function (newVal, val) {
      if(newVal.name == "Simulation") {
        this.setSectionTwo();
      }
      if(newVal.name == "Change Management in Your Work") {
        this.setSectionThree();
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const lessonsList =
      this.module.model &&
      this.module.model.lessons[0].activities.map(activity => (
            <li class="p-1 px-2 flex text-brand-blue-200" key={activity.name} onClick={() => this.setActivity(activity, this.module.model.lessons[0])}>
              {this.getActivityIcon(activity)}
              {activity.name}
          </li>
          ));
    const activeBorder = "p-3 lg:px-16 font-bold border-t-8 border-orange-600 flex items-center justify-center h-full";
    const inActiveBorder = "p-3 lg:px-16 font-bold border-t-8 border-brand-gray-800 h-full flex items-center justify-center h-full";
    return (
      <div class="bg-gray-300">
        <div class="container mx-auto lg:px-6">
          <div class="bg-gray-700">
            <ul class="relative flex border-b-2 border-blue-300 bg-white text-center text-xs lg:text-lg">
              <li class="relative w-1/3 cursor-pointer" onClick={this.setSectionOne}>
                <div class={(this.currentSection==1) ? activeBorder : inActiveBorder}>
                <span class="text-brand-gray-800">
                  Preparing for Change
                  </span>
                </div>
                {this.currentSection==1 && (<div class="arrow-down absolute bottom-0 transform translate-x-1/2 translate-y-3 right-1/2 z-50"></div>)}
              </li>
              <li class="relative md:w-1/3 border-l border-blue-300 cursor-pointer" onClick={this.setSectionTwo}>
                <div class={(this.currentSection==2) ? activeBorder : inActiveBorder}>
                  <span class="text-brand-gray-800">
                    Change Management Simulation
                  </span>
                  {this.section2Locked && (<img
                    src="/img/changemanagement/lock-outline-circle.svg"
                    alt="locked"
                    class="w-4 lg:w-8 float-right ml-1 lg:ml-2"
                  />)}
                  {this.currentSection==2 && (<div class="arrow-down absolute bottom-0 transform translate-x-1/2 translate-y-3 right-1/2 z-50"></div>)}
                </div>
              </li>
              <li class="relative md:w-1/3 border-l border-blue-300 cursor-pointe" onClick={this.setSectionThree}>
              <div class={(this.currentSection==3) ? activeBorder : inActiveBorder}>
                  <div class="flex items-center justify-center h-full">
                  <span class="text-brand-gray-800">
                    Change Management in Your Work
                  </span>
                    {this.section3Locked && (<img
                      src="/img/changemanagement/lock-outline-circle.svg"
                      alt="locked"
                      class="w-4 lg:w-8 float-right ml-1 lg:ml-2"
                    />)}
                    {this.currentSection==3 && (<div class="arrow-down absolute bottom-0 transform translate-x-1/2 translate-y-3 right-1/2 z-50"></div>)}
                  </div>
                </div>
              </li>
            </ul>
            {this.currentSection == 1 && (
              <div class="py-5 lg:py-0 lg:h-20 lg:w-10/12 lg:mx-auto">
                <ul class="h-full flex flex-col lg:flex-row lg:items-center lg:justify-center text-sm lg:text-center text-white mx-4 lg:mx-0">
                  {lessonsList}
                </ul>
              </div>
            )}
            {this.currentSection == 1 && (
              <iframe src={this.iframesrc} width="100%" height="550"/>
            )}
            {this.currentSection == 2 && (
              <Simulation activity="this.activity" onComplete={this.completeActivity} />
            )}
            {this.currentSection == 3 && (
              <ChangeManagementSection3 activity="this.activity" onComplete={this.completeActivity} />
            )}
          </div>
        </div>
      </div>
    );
  },
};
